import * as React from "react";

import { IPageContainerState } from "@montana/containers/page";
import { Container } from "@montana/shared/container";
import { DynamicBlocks } from "@montana/blocks/dynamic-blocks.component";

export const StandardPage: React.FC<IPageContainerState> = React.memo((props: IPageContainerState): JSX.Element => {

    const { blocks } = props;

    return (
        <Container>
            <DynamicBlocks blocks={blocks} isFirstElementOnPage />
        </Container>
    );
});
